import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Shukla module landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); a card shows only when the person may
 * open it, so India accounts see only their own modules. The Reports & KPI card opens the
 * KPI hub on the Shukla tab. The route is gated by dept.shukla in allRoutes.js.
 */
const MODULES = ["display", "di", "app-mafia", "dms", "cr", "tasks", "epo", "kpi"];

const Shukla = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-building-2-line"
                        eyebrow="Shukla Medical"
                        title="Shukla"
                        subtitle="Tools and reports for the Shukla Medical line"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shukla" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="shukla" title="Shukla modules" icon="ri-building-2-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-building-2-line"
                        title="More for Shukla later"
                        message="Ideas for later: Shukla production reports, component traceability and lot release. The modules above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shukla;
